import { AbstractControl, ValidatorFn } from "@angular/forms";
import { Utility } from "@ignite/ignite-common";
import { IgnitePasswordComponent } from "../components/ignite-password/ignite-password.component";

export function PasswordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (Utility.IsEmptyOrNull(control.value)) {
      return null;
    }

    const pwd = control.value as string;

    const results = {};
    if (
      Utility.IsEmptyOrNull(pwd) ||
      pwd.length < IgnitePasswordComponent.MINIMUM_PASSWORD_LENGTH ||
      pwd.length > IgnitePasswordComponent.MAXIMUM_PASSWORD_LENGTH
    ) {
      results["size"] = pwd.length;
    }

    if (!Utility.IsEmptyOrNull(pwd)) {
      if (!new RegExp(/[a-z]/).test(pwd)) {
        results["lower"] = pwd;
      }
      if (!new RegExp(/[0-9]/).test(pwd)) {
        results["number"] = pwd;
      }
      if (!new RegExp(/[A-Z]/).test(pwd)) {
        results["capital"] = pwd;
      }
      if (!new RegExp(/[~`! @#$%^&*()_\-+={[\]}|\\:;"'<,>.?/]/).test(pwd)) {
        results["schar"] = pwd;
      }
    }
    return results;
  };
}
